module.exports = __webpack_public_path__ + "img/twitter.8bec14fd.svg";